// extracted by mini-css-extract-plugin
module.exports = {"iconProfile":"styles_iconProfile__1v74z","newTask":"styles_newTask__3khsA","nav":"styles_nav__UKpzI"};